import React from 'react';
import { useTranslate } from 'react-redux-multilingual';
//Material
import { Grid, Stack } from '@mui/material';

//Components
import Page from '../../components/Page';

//Blocks

import './index.css';
import 'animate.css';
import TopBlock from './Blocks/TopBlock';
// import AboutUsBlock from './Blocks/AboutUsBlock';
// import ContentBlock from './Blocks/ContentBlock';
import BottomBlock from './Blocks/BottomBlock';
import { connect } from 'react-redux';
import TariffsBlock from './Blocks/TariffsBlock';

// import { useSelector } from 'react-redux';

function MainPage({ language, userData }) {
  const translate = useTranslate();
  const microdata = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Хто може користуватися платформою?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Наша платформа створена для виробників, фермерів, ремісників, стартапів, підприємців тощо, які хочуть розширити свій бізнес, а також для покупців, які шукають унікальні та якісні товари.'
        }
      },
      {
        '@type': 'Question',
        name: 'Як почати продавати?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '1. Зареєструйтеся на платформі. 2. Створіть сторінку свого бренду. 3 .Додайте товар. 4. Почніть отримувати замовлення. Щоб отримати більше можливостей, скористайтеся преміум-підпискою.'
        }
      },
      {
        '@type': 'Question',
        name: 'Що таке преміум-підписка і які її переваги?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Преміум відкриває розширені можливості для продавців: ✔️ Необмежена кількість товарів для створення ✔️ Календар замовлень ✔️ Просування акаунту та товарів ✔️ Аналітика та звітність Ознайомитися з тарифами можна на сторінці тарифів.'
        }
      },
      {
        '@type': 'Question',
        name: 'Як купити преміум-тариф і коли він активується?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '1. Зареєструйтесь на платформі. 2. Перейдіть на сторінку тарифів та оберіть потрібний план. 3. Виконайте оплату через LiqPay. 4. Підписка активується миттєво після підтвердження платежу. Підтвердження про активацію буде надіслано на ваш email. Детальна інформація про покупку доступна в користувальницькій угоді, пункт 11.'
        }
      },
      {
        '@type': 'Question',
        name: 'Які способи оплати доступні?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Ми підтримуємо оплату банківськими картами (Visa, MasterCard) через Monopay. Оплату можна здійснити через сервіс Monopay під час оформлення підписки.'
        }
      },
      {
        '@type': 'Question',
        name: 'Чи можна скасувати підписку або отримати повернення?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Так, ви можете скасувати підписку в будь-який момент. Однак кошти за використаний період не повертаються. Якщо виникли технічні проблеми або кошти були стягнуті помилково, зверніться в службу підтримки. Більше деталей про повернення – в користувальницькій угоді, пункт 12.'
        }
      }
    ]
  };

  return (
    <Page
      title={translate('bonfair_pageName')}
      description={
        'Ми – українська Social Selling платформа, що поєднала торговий майданчик та соціальну мережу в одному місці через створення довірчих відносин між виробником і покупцем.'
      }
      microdata={microdata}
      isIndex={true}
      canonical={window.location.origin + window.location.pathname.replace(/^\/ua/, '/')}
    >
      <Stack spacing={1} justifyContent="center" alignItems="center" width="100%">
        <Grid
          container
          style={{
            maxWidth: '1440px'
          }}
        >
          <TopBlock />
          {!userData || (userData && userData?.role !== 'PREMIUM_USER') ? <TariffsBlock /> : null}

          {/* {userData?.id && <ContentBlock />} */}

          <BottomBlock />
        </Grid>
      </Stack>
    </Page>
  );
}
const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData
  };
};

export default connect(mapStateToProps)(MainPage);
